import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const Feepavati2 = () => {
  const [htmlContent, setHtmlContent] = useState('');
  const [studentDetails, setStudentDetails] = useState([]);
  const [feeData, setFeeData] = useState({});
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const udiseNumber = localStorage.getItem("udiseNumber");
  const [filteredFeeDetails, setFilteredFeeDetails] = useState({});
  const [allData, setAllData]=useState({})
  const location = useLocation();
  const navigate = useNavigate();
  const {year, selectedClass, selectedFeeType, schoolDetails } = location.state || {};


  const language = localStorage.getItem("language");
  const [rootData, setRootData] = useState({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/root/${year}.json`);
        const data = await response.json();
        setRootData(data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [udiseNumber]);

  useEffect(() => {
    const fetchStudentData = async () => {
      const studentUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentData.json`;
      const studentResponse = await fetch(studentUrl);
      const studentData = await studentResponse.json();

      if (!studentData || Object.keys(studentData).length === 0) {
        console.warn("No student data found for the given udiseNumber.");
        setStudentDetails([]);
        return;
      }

      const studentArray = Object.values(studentData).filter(student => student !== null && (student.isActive === true || student.isActive === undefined));
      setStudentDetails(studentArray);
    };

    const fetchFeeData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/fees/${year}.json`);
        const data = await response.json();
        setFeeData(data);
        setIsDataLoaded(true);
        console.log("data", data);
      } catch (error) {
        console.error('Error fetching fee data:', error);
      }
    };

    fetchStudentData();
    fetchFeeData();
  }, [udiseNumber]);

  const fetchClassWiseFeeDetails = async (udiseNumber, selectedClass) => {
    try {
      const feeUrl = `${process.env.REACT_APP_FIREBASE_DATABASE_URL}/schoolRegister/${udiseNumber}/studentFee/${year}.json`;
      const response = await fetch(feeUrl);
  
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
  
      const data = await response.json();
      console.log('Fetched dataAAAAA:', data);
      setAllData(data);
  
      if (!data || typeof data !== 'object') {
        console.log('No valid data available');
        return {}; // Exit early if data is not valid
      }
  
      const filteredData = {};
  
      for (const serialNo in data) {
        if (serialNo === 'lastInvoiceNo') continue;
  
        const invoices = data[serialNo];
        if (!invoices || typeof invoices !== 'object') continue;
  
        filteredData[serialNo] = {};
  
        for (const invoiceNo in invoices) {
          const studentFees = invoices[invoiceNo];
          if (!studentFees || typeof studentFees !== 'object') continue;
  
          for (const feeKey in studentFees) {
            const studentFee = studentFees[feeKey];
            if (!studentFee) continue;
  
            const { class: feeClass } = studentFee;
            const isClassMatch = selectedClass === "All" || feeClass === selectedClass;
  
            // If the class matches, add the fee data
            if (isClassMatch) {
              filteredData[serialNo][invoiceNo] = filteredData[serialNo][invoiceNo] || {};
              filteredData[serialNo][invoiceNo][feeKey] = studentFee;
            }
          }
  
          if (Object.keys(filteredData[serialNo] || {}).length === 0) {
            delete filteredData[serialNo];
          }
        }
      }
  
      console.log('Filtered data:', filteredData);
      return filteredData;
    } catch (error) {
      console.error('Error fetching fee details:', error);
      return {};
    }
  };
  const getBaseFeetype = (feetype) => {
    const lastIndex = feetype.lastIndexOf('-');
    return lastIndex !== -1 ? feetype.substring(0, lastIndex) : feetype; // Return the part before the last '-' or the whole feetype if '-' is not found
};
  useEffect(() => {
    console.log('Selected Class:', selectedClass);
  
    // Now only pass selectedClass and udiseNumber, no need to pass selectedYear or selectedDivision
    fetchClassWiseFeeDetails(udiseNumber, selectedClass)
      .then(feeDetails => {
        console.log('Fetched fee details:', feeDetails);
        setFilteredFeeDetails(feeDetails);
      })
      .catch(error => console.error('Error updating fee details:', error));
  }, [selectedClass, udiseNumber]);

  useEffect(() => {
    if (isDataLoaded) {
      const tableRows = studentDetails
        .filter(student => student.currentClass && student.currentClass.toString() === selectedClass.toString())
        .map(student => {
          const fee = Object.values(feeData).find(
            fee => fee.classType === selectedClass && fee.feetype === selectedFeeType
          );

          const studentName = student.stdName || '-';
          const feeType = fee ? fee.feetype : '-';
          const amount = fee ? fee.amount : '-';
          const remainingFee = amount;

          return `
            <tr>
              <td>${studentName}</td>
              <td>${feeType}</td>
              <td>${amount}</td>
            </tr>
          `;
        }).join('');

      const reportContent = `
        <div style="padding: 20px; font-family: Arial, sans-serif; display: flex; justify-content: center;">
          <div style="border: 1px solid black; margin-bottom: 10px; background-color: #F7F7F7; padding: 10px; width: 80%; max-width: 1100px;">
            <h4 style="margin: 0; text-align: center;">${schoolDetails?.sansthaName || ' '}</h4>
            <h2 style="margin: 0; text-align: center;">${schoolDetails?.schoolName || ' '}</h2>
            <div style="text-align: center; margin-top: 10px;">
              <p style="margin: 0;">Taluka: ${schoolDetails?.taluka || '-'}, District: ${schoolDetails?.jilha  || '-'}</p>
            </div>
            <h3 style="
              display: block;
              border: 1px solid black;
              background-color: black;
              color: white;
              padding: 2px;
              width: 200px;
              text-align: center;
              margin: 10px auto;
              border-radius: 10px;
            ">Fee Report</h3>
            <table border="1" cellpadding="5" cellspacing="0" style="width: 100%; border-collapse: collapse;">
              <thead>
                <tr>
                  <th>Student Name</th>
                  <th>Fee Type</th>
                  <th>Fee</th>
                  <th>Discount (RS)</th>
                  <th>After Discount Fee</th>
                  <th>Paid Fee</th>
                  <th>Remaining Fee</th>
                </tr>
              </thead>
              <tbody>
                ${tableRows}
              </tbody>
            </table>
          </div>
        </div>
      `;

      setHtmlContent(reportContent);
    }
  }, [isDataLoaded, studentDetails, feeData, schoolDetails]);

  const handlePrint = () => {
    const printWindow = window.open('', '', 'height=600,width=800');
  
    // Create the content to print using the current data
    const printContent = `
      <html>
        <head>
          <title> Fee Report</title>
          <style>
            body { 
              font-family: Arial, sans-serif; 
              padding: 0px; 
              margin: 0; 
              background-color: #f4f4f4; 
            }
            @page {
              size: A4 Portrait;
              margin: 3mm; /* this affects the margin in the printer settings */
            }
            .report-container {
              border: 1px solid black;
              padding: 10px;
              margin: 10px auto;
              box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
              width: auto;
              background-color: white;
            }
            .school-details {
              text-align: center;
              margin-bottom: 20px;
            }
            .report-title {
              display: block;
              border: 1px solid black;
              background-color: black;
              color: white;
              padding: 5px;
              width: 200px;
              text-align: center;
              margin: 10px auto;
              border-radius:6x;
            }
            table { 
              width: 100%; 
              border-collapse: collapse; 
              margin-top: 20px;
              border: 1px solid black; /* Added border to the table */
            }
            th, td { 
              border: 1px solid black; /* Changed border color to black */
              padding: 8px; 
              text-align: center; 
            }
            th { 
              background-color: #6495ED; 
              color: white; 
            }
            .sr-no, .class, .roll-no {
              padding:8px 2px !important; 
            }
            @media print {
              .page-number {
                position: fixed;
                bottom: 0;
                right: 0;
                font-size: 12px;
                margin: 10px;
              }
            }
          </style>
        </head>
        <body>
          <div class="report-container">
            ${schoolDetails ? `
              <div class="school-details">
                <h6>${schoolDetails.sansthaName || ''}</h6>
                <h4>${schoolDetails.schoolName || ''}</h4>
                <p>${language === "English" ? "Taluka" : "तालुका"}: ${schoolDetails.taluka || ''}, ${language === "English" ? "District" : "जिल्हा"}: ${schoolDetails.jilha || ''}</p>
                <h2 class="report-title">${language === "English" ? "Fee Report" : "फी अहवाल"}</h2>
              </div>
            ` : ''}
            
            <table>
              <thead>
                <tr>
                  <th class="sr-no">${language === "English" ? "Sr. No" : "अनु.क्र."}</th>
                  <th class="class">${language === "English" ? "Class" : "वर्ग"}</th>
                  <th class="roll-no">${language === "English" ? "Roll No" : "हजेरी क्र"}</th>
                  <th class="roll-no">${language === "English" ? "Student Name" : "विद्यार्थ्याचे नाव"}</th>
                  <th class="roll-no">${language === "English" ? "Fee Type" : "फी प्रकार"}</th>
                  <th class="roll-no">${language === "English" ? "Fee" : "फी"}</th>
                  <th class="roll-no">${language === "English" ? "Discount (RS)" : "सवलत (RS)"}</th>
                  <th class="roll-no">${language === "English" ? "After Discount Fee" : "सवलतीनंतरची फी" }</th>
                  <th class="roll-no">${language === "English" ? "Paid Fee" : "दिलेली फी"}</th>
                  <th class="roll-no">${language === "English" ? "Remaining Fee" : "उर्वरित फी"}</th>
                </tr>
              </thead>
              <tbody>
                ${studentDetails
                  .filter(student => student.currentClass && (selectedClass === "All" || student.currentClass.toString() === selectedClass.toString()))
                  .map((student, index) => {
                    const feeForClass = Object.values(feeData).find(
                      fee => fee.classType === selectedClass && fee.feetype === selectedFeeType
                    );
                    const feeForAll = Object.values(feeData).find(
                      fee => fee.classType === "All" && fee.feetype === selectedFeeType
                    );
  
                    const fee = selectedClass === "All" ? feeForAll : feeForClass;
                    const feeTypeToShow = fee ? fee.feetype : (feeForAll ? feeForAll.feetype : '0');
  
                    const discountAmount = fee ? fee.discountAmount || 0 : 0;
                    const amount = fee ? fee.amount || 0 : (feeForAll ? feeForAll.amount || 0 : '0');
  
                    const studentFeeDetails = filteredFeeDetails[student.serialNo] || {};
                    const lastInvoiceNo = Math.max(...Object.keys(studentFeeDetails).map(Number), 0);
                    const lastInvoiceDetails = lastInvoiceNo ? studentFeeDetails[lastInvoiceNo] : {};
  
                    const lastFeeTypeDetails = lastInvoiceDetails[selectedFeeType] || {};
                    const lastDiscountAmount = lastFeeTypeDetails.discountAmount || '0';
                    const lastBeforePay = lastFeeTypeDetails.beforePay || '0';
  
                    const remainingFee = (amount - lastDiscountAmount) - lastBeforePay;
  
                    return `
                      <tr key=${index}>
                        <td class="sr-no">${index + 1}</td>
                        <td class="class">${student.currentClass || ''}</td>
                        <td class="roll-no">${student.rollNo || ''}</td>
                        <td class="sr-no">${student.stdName || ''}</td>
                        <td class="sr-no">${getBaseFeetype(feeTypeToShow) || ''}</td>
                        <td class="sr-no">${amount || ''}</td>
                        <td class="sr-no">${lastDiscountAmount || ''}</td>
                        <td class="sr-no">${(amount - lastDiscountAmount).toFixed(2) || ''}</td>
                        <td class="sr-no">${lastBeforePay || ''}</td>
                        <td class="sr-no">${remainingFee.toFixed(2) || ''}</td>
                      </tr>
                    `;
                  }).join('')}
              </tbody>
            </table>
          </div>
          <div class="page-number">Page 1</div>
        </body>
      </html>
    `;
  
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };

  const handleGoBack = () => {
    navigate(-1); // Use navigate to go back
  };

  return (
    
    <div className='main-content-of-page'>
     <button 
  onClick={handleGoBack} 
  style={{
    backgroundColor: '#FFFFFF',
    color: 'black',
    padding: '7px 20px',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    marginTop: '30px',
    display: 'block',
    marginLeft: '40px',
    marginRight: 'auto',
    border: '1px solid black',
  }}
>
  <i className="fa fa-arrow-left" style={{ fontSize: '22px', marginRight: '8px' }}></i>
  Go Back
</button>
     <button 
        onClick={handlePrint} 
        style={{
          backgroundColor: '#6495ED',
          color: 'white',
          padding: '10px 20px',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
          marginTop: '-42px',
          display: 'block',
          marginLeft: '200px',
          marginRight: 'auto'
        }}
      >
        Print Report
      </button>
      <div style={{
        border: '2px solid black',
        padding: '20px',
        margin: '20px auto',
        boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
        width: '1000px'
      }}>
        {schoolDetails && (
          <div style={{ marginBottom: '20px', textAlign: 'center' }}>
            <h6>{schoolDetails.sansthaName}</h6>
            <h4>{schoolDetails.schoolName}</h4>
            <p>{language==="English"?"Taluka":"तालुका"}: {schoolDetails.taluka},{language==="English"?"District":"जिल्हा"} : {schoolDetails.jilha}</p>
            <h2 style={{
              display: 'block',
              border: '1px solid black',
              backgroundColor: 'black',
              color: 'white',
              padding: '5px',
              width: '200px',
              textAlign: 'center',
              margin: '0 auto',
              borderRadius: '8px'
            }}>{language==="English"?"Fee Report":"फी अहवाल"} </h2>
          </div>
        )}
        {isDataLoaded ? (
  <div>
    <table>
      <thead>
        <tr>
          <th style={{backgroundColor:'#6495ED'}}> {language==="English"? "Sr. No":"अनु.क्र."}</th>
          <th style={{backgroundColor:'#6495ED'}}>{language==="English"? "Class":"वर्ग"}</th>
          <th style={{backgroundColor:'#6495ED'}}>{language==="English"? "Roll No":"हजेरी क्र"}</th>
          <th style={{backgroundColor:'#6495ED'}}>{language==="English"? "Student Name":"विद्यार्थ्याचे नाव"}</th>
          <th style={{backgroundColor:'#6495ED'}}>{language==="English"? "Fee Type":"फी प्रकार"}</th>
          <th style={{backgroundColor:'#6495ED'}}>{language==="English"? "Fee":"फी"}</th>
          <th style={{backgroundColor:'#6495ED'}}>{language==="English"? "Discount (RS)":"सवलत (RS)"}</th>
          <th style={{backgroundColor:'#6495ED'}}>{language==="English"? "After Discount Fee":"सवलतीनंतरची फी"}</th>
          <th style={{backgroundColor:'#6495ED'}}>{language==="English"? "Paid Fee":"दिलेली फी"}</th>
          <th style={{backgroundColor:'#6495ED'}}>{language==="English"? "Remaining Fee":"उर्वरित फी"}</th>
        </tr>
      </thead>
      <tbody>
        {studentDetails
          .filter(student => student.currentClass && (selectedClass === "All" || student.currentClass.toString() === selectedClass.toString()))
          .map((student, index) => {
            // Find matching fee details for the selected class and fee type
            const feeForClass = Object.values(feeData).find(
              fee => fee.classType === selectedClass && fee.feetype === selectedFeeType
            );
            const feeForAll = Object.values(feeData).find(
              fee => fee.classType === "All" && fee.feetype === selectedFeeType
            );

            // Determine which fee to use
            const fee = selectedClass === "All" ? feeForAll : feeForClass;
            const feeTypeToShow = fee ? fee.feetype : (feeForAll ? feeForAll.feetype : '0');

            // Set default values
            const discountAmount = fee ? fee.discountAmount || 0 : 0;
            const amount = fee ? fee.amount || 0 : (feeForAll ? feeForAll.amount || 0 : '0');

            // Check if there are fee details for the current student in filteredFeeDetails
            const studentFeeDetails = filteredFeeDetails[student.serialNo] || {};
            const lastInvoiceNo = Math.max(...Object.keys(studentFeeDetails).map(Number), 0);
            const lastInvoiceDetails = lastInvoiceNo ? studentFeeDetails[lastInvoiceNo] : {};

            // Access fee details from lastInvoiceDetails
            const lastFeeTypeDetails = lastInvoiceDetails[selectedFeeType] || {};
            const lastDiscountAmount = lastFeeTypeDetails.discountAmount || '0'; // Default to '0'
            const lastBeforePay = lastFeeTypeDetails.beforePay || '0'; // Default to '0'

            // Calculate the remainingAmount as amount - lastDiscountAmount
            const remainingAmount = amount - lastDiscountAmount;
            const lastRemainingAmount = (lastFeeTypeDetails.remainingAmount || amount) - lastBeforePay; // Updated calculation

            // Special handling for Bus Fee
            let busFeeAmount = '0';
            if (selectedFeeType === 'Bus Fee') {
              // Check the rootData for the amount based on studentSerialNo
              for (const rootKey in rootData) {
                const root = rootData[rootKey];
                if (root.studentSerialNo && root.studentSerialNo[student.serialNo]) {
                  busFeeAmount = root.amount1; // Get the amount for this root
                  break; // Exit the loop once we find the matching studentSerialNo
                }
              }
            }

            const feeAmount = selectedFeeType === 'Bus Fee' ? busFeeAmount : amount;
      const afterDiscountFee = feeAmount - lastDiscountAmount; // Calculate After Discount Fee
      const remainingFee = afterDiscountFee - lastBeforePay; // Calculate Remaining Fee
      

            return (
              <tr key={index}>
                <td>{index+1}</td>
                <td>{student.currentClass}</td>
                <td>{student.rollNo}</td>
                <td>{student.stdName} {student.stdFather} {student.stdSurname}</td>
                <td>{getBaseFeetype(feeTypeToShow)}</td>
                <td>{feeAmount}</td> {/* Show bus fee amount if applicable */}
                <td>{lastDiscountAmount}</td> {/* Display last discount amount */}
                <td>{afterDiscountFee.toFixed(2)}</td> {/* Updated remaining amount */}
                <td>{lastBeforePay}</td> {/* Display last before payment */}
                <td>{remainingFee}</td> {/* Display last remaining amount */}
              </tr>
            );
          })}
      </tbody>
    </table>
  </div>
) : (
  <p>Loading...</p>
)}
      </div>
    {/* Render the print button outside of the main div */}
    <style jsx>{`
   .report-title {
              display: block;
              border: 1px solid black;
              background-color: black;
              color: white;
              padding: 4px;
              width: 200px;
              text-align: center;
              margin: 10px auto;
              border-radius:6px;
            }
             table { 
              width: 100%; 
              border-collapse: collapse; 
              margin-top: 20px;
              border: 1px solid black; /* Added border to the table */
            }
            th, td { 
              border: 1px solid black; /* Changed border color to black */
              padding: 8px; 
              text-align: center; 
            }
            th { 
              background-color: #6495ED; 
              color: white; 
            }
  `}</style>
    </div>
  );
};

export default Feepavati2;
